import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Loader from '../../../components/Common/Loader/Loader';
import AddSubCategoryForm from '../../../components/SiteAdmin/AddSubCategoryForm/AddSubCategoryForm';
import NotFound from '../../../components/NotFound/NotFound';
import getSubCategory from './getSubCategory.graphql';
import getActiveCategories from '../addSubCategory/getActiveCategories.graphql';
import messages from '../../../locale/messages';
import { withQuery } from '../../../hoc/withGraphql';

export class EditSubCategory extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired
    }
    static defaultProps = {
        data: {
            loading: true
        }
    }
    render() {
        const { data: { loading, getSubCategory }, data, id } = this.props;
        const { formatMessage } = this.props.intl;
        const { categories } = this.props;

        let initialValues = {};

        if (!loading && getSubCategory?.status === 200 && getSubCategory?.result) {
            initialValues = {
                id: getSubCategory?.result?.id,
                name: getSubCategory?.result?.name,
                description: getSubCategory?.result?.description,
                image: getSubCategory?.result?.image,
                categoryId: getSubCategory?.result?.categoryId,
                status: getSubCategory?.result?.status
            }
        }

        if (!loading && !getSubCategory?.result?.id) {
            return <NotFound title={formatMessage(messages.pageNotFound)} />;
        } else {
            return (
                <Loader type={"page"} show={loading}>
                    {!loading && <AddSubCategoryForm initialValues={initialValues} categories={categories} />}
                </Loader>
            )
        }
    }
}

export default compose(injectIntl,
    withQuery(getSubCategory, {
        options: (props) => ({
            variables: {
                id: Number(props.id)
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    }),
    withQuery(getActiveCategories, {
        name: 'categories',
        options: {
            ssr: false,
            fetchPolicy: 'network-only'
        }
    }))(EditSubCategory)
